import { addDays, differenceInDays, endOfMonth } from 'date-fns';

const getFortyFiveDaysEndOfMonth: (s: number) => number = (startAt) => {
  // When "45 days end of month" is chosen, we compute the lateMaxDays value
  // by adding 45 days and then going to the end of the month the invoice is emitted
  const endDate = endOfMonth(addDays(new Date(startAt), 45));
  return differenceInDays(endDate, new Date(startAt));
};

export default getFortyFiveDaysEndOfMonth;
